module.exports = __webpack_public_path__ + "img/IMG_8458.fb58d488.jpg";